import { SeatType } from '@vista-digital/ocapi-types/v1';
import { SeatSelectionRuleName } from '../../types/seat-selection-rule-name';
import { hasAvailableAndNotSelectedWheelchairSeatsInGroup } from '../seat-utils';
const ruleName = SeatSelectionRuleName.MustSelectAssociatedWheelchairSeat;
/**
 * Rule that prevents a companion seat from being sold unless the associated wheelchair seat is also selected.
 */
export const mustSelectAssociatedWheelchairSeatRule = () => {
    return {
        name: ruleName,
        validate: (data, selectedSeats) => {
            const hasCompanionWithoutWheelchair = selectedSeats.some(seat => {
                if (seat.type !== SeatType.Companion)
                    return false;
                return hasAvailableAndNotSelectedWheelchairSeatsInGroup(data, selectedSeats, seat);
            });
            return {
                ruleName: ruleName,
                isValid: !hasCompanionWithoutWheelchair
            };
        }
    };
};
